import React, { useState } from "react";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import CustomTable from "../components/Table";

const PerformanceIndicator = () => {
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");

  const data = [
    { key: "1", designation: "Web Designer", dept: "Designing", approved: "Antony", date: "14 Jan 2024", status: "Active" },
    { key: "2", designation: "iOS Developer", dept: "Development", approved: "Antony", date: "14 Jan 2024", status: "Active" },
    { key: "3", designation: "Web Developer", dept: "Designing", approved: "Antony", date: "14 Jan 2024", status: "Active" },
    { key: "4", designation: "Android Developer", dept: "Development", approved: "Antony", date: "14 Jan 2024", status: "Active" },
  ];

  const filteredData = data.filter((item) =>
    item.designation.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    { title: "", render: () => <input type="checkbox" />, width: 50 },
    { title: "Designation", dataIndex: "designation" },
    { title: "Department", dataIndex: "dept" },
    { title: "Approved By", dataIndex: "approved" },
    { title: "Created Date", dataIndex: "date" },
    { title: "Status", dataIndex: "status" },
    {
      title: "Action",
      render: () => (
        <div className="action-icons">
          <EditOutlined />
          <DeleteOutlined />
        </div>
      ),
    },
  ];

  return (
    <CustomTable
      title="Performance Indicator List"
      columns={columns}
      data={filteredData}
      pageSize={pageSize}
      setPageSize={setPageSize}
      onSearch={setSearchText}
    />
  );
};

export default PerformanceIndicator;